import React from 'react';
import { 
  Briefcase,
  FileText,
  BarChart, 
  MessageSquare,
  ListTodo,
  Users,
} from 'lucide-react';

export const NavigationItems = [
  { text: 'Cases', icon: <Briefcase />, path: '/cases' },
  { text: 'Documents', icon: <FileText />, path: '/documents' },
  { text: 'Task Templates', icon: <ListTodo />, path: '/task-templates' },
  { text: 'Reports', icon: <BarChart />, path: '/reports' },
  { text: 'Messages', icon: <MessageSquare />, path: '/messages' },
  { text: 'Users & Roles', icon: <Users />, path: '/users' },
];